const WELCOME_SEEN_KEY = 'welcomeModalSeen'

const seenKey = (userId) => `${WELCOME_SEEN_KEY}:${userId}`

export const isFirstLogin = (user) => user?.sign_in_count === 1

export const hasSeenWelcome = (userId) => !!localStorage.getItem(seenKey(userId))

export const markWelcomeSeen = (userId) => localStorage.setItem(seenKey(userId), 'true')
